import crypto from 'crypto';
import { WckAuthCookie } from '@wconcept/wconcept-common/models/display/common';
import { isEmpty } from '../baseUtils';

const isSsr = (): boolean => typeof window === 'undefined';
export const decodeCookie = (cookieKey: string, cookieName: string) => {
  let result;
  if (cookieKey) {
    try {
      // wckBridgeAuth 쿠키 key, iv default로 처리, cookieKey가 wckConnectionAuth 이면 wckConnectionAuth의 key, iv 사용
      let key =
        process.env.NEXT_PUBLIC_WCK_BRIDGE_AUTH_DATA_KEY ||
        (process.env.WCK_BRIDGE_AUTH_DATA_KEY as string);
      let iv =
        process.env.NEXT_PUBLIC_WCK_BRIDGE_AUTH_DATA_IV ||
        (process.env.WCK_BRIDGE_AUTH_DATA_IV as string);

      if (cookieName === process.env.NEXT_PUBLIC_WCK_AUTH_COOKIE_KEY) {
        key =
          process.env.NEXT_PUBLIC_WCK_AUTH_DATA_KEY ||
          (process.env.WCK_AUTH_DATA_KEY as string);
        iv =
          process.env.NEXT_PUBLIC_WCK_AUTH_DATA_IV ||
          (process.env.WCK_AUTH_DATA_IV as string);
      }
      // Base64로 인코딩된 키와 IV를 버퍼로 변환
      const keyBuffer = Buffer.from(key, 'base64');
      const ivBuffer = Buffer.from(iv, 'base64');

      // 복호화 객체 생성
      const decipher = crypto.createDecipheriv(
        'aes-256-cbc',
        keyBuffer as unknown as crypto.CipherKey,
        ivBuffer as unknown as crypto.BinaryLike
      );

      // 패딩 설정
      decipher.setAutoPadding(true);

      // 복호화 실행
      let decrypted = decipher.update(cookieKey, 'base64', 'utf8');
      decrypted += decipher.final('utf8');
      // 결과 처리
      const authData = decodeURIComponent(decrypted);
      result = JSON.parse(authData) as unknown;
    } catch (e) {
      console.log(e);
    }
  }
  return result;
};

// WckAuthData 정보 조회.

export const getCookieWckAuthData = async () => {
  let wckAuthData: WckAuthCookie = {
    userNo: '0',
    userId: '',
    userName: '',
    gender: '',
    grade: '8',
    gradeName: '',
    birth: '',
    mobile: '',
    isCert: false,
    isPasswordChange: false,
    isAuthLogin: false,
    lastLoginDate: '',
    joinDate: '',
    lastOrderDate: '',
    snsType: '',
    loginType: '',
    smsYN: '',
    emailYN: '',
    pushYN: '',
    adYN: '',
    liveAlarmYN: '',
    isEmployee: '',
    cooperationCompanyCode: '',
    cookieCreateDate: '',
    locationAgreementYN: '',
    kakaotalkYN: '',
  };

  const bridgeCookieKey = process.env
    .NEXT_PUBLIC_WCK_BRIDGE_AUTH_COOKIE_KEY as string;
  const cookieKey = process.env.NEXT_PUBLIC_WCK_AUTH_COOKIE_KEY as string;

  let wckAuthCookie = '';
  let cookieName = bridgeCookieKey;

  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    wckAuthCookie = cookie.get(bridgeCookieKey)?.value as string;
    if (isEmpty(wckAuthCookie)) {
      cookieName = cookieKey;
      wckAuthCookie = cookie.get(cookieKey)?.value as string;
    }
  } else {
    const { getCookie } = await import('cookies-next');
    wckAuthCookie = getCookie(bridgeCookieKey) as string;
    if (isEmpty(wckAuthCookie)) {
      cookieName = cookieKey;
      wckAuthCookie = getCookie(cookieKey) as string;
    }
  }

  const auth = decodeCookie(wckAuthCookie, cookieName) as WckAuthCookie;
  if (auth) {
    wckAuthData = auth;
    if (!isEmpty(wckAuthData.userNo)) {
      if (wckAuthData.grade === '0') {
        wckAuthData.grade = '6';
      }
    } else {
      wckAuthData.grade = '8';
    }
  }

  if (!isEmpty(wckAuthData.userNo) && isEmpty(wckAuthData.kakaotalkYN)) {
    wckAuthData.kakaotalkYN = 'N';
  }

  return wckAuthData;
};

// custno 정보 조회.

export const getCookieWckAuthGrade = async () => {
  const wckAuthData = await getCookieWckAuthData();
  if (!isEmpty(wckAuthData.userNo)) {
    // 예외처리.
    if (wckAuthData.grade === '0') {
      return '6';
    }
    return wckAuthData.grade;
  }
  return '8';
};
